/* global  moment, _ */
import './style.less';
import { orderBy, get } from 'lodash';

export default function($log, $stateParams, $filter, $scope, ApiClass, UserClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.adminView = !!$stateParams.employeeID;

  vm.resultsQueried = false;

  $scope.disableButtons = get(ProfileClass, 'profileComplete.company.preferences.read_only.user.courses');

  const profile_uid = $stateParams.employeeID || $stateParams.id;

  vm.pagination = {
    currentPage: 1,
    numPerPage: 15,
    setPage: pageNo => {
      vm.pagination.currentPage = pageNo;
    }
  };

  vm.isAdmin = UserClass.isAdmin || UserClass.isTeamLeader;

  vm.removeCourse = course_id => {
    ApiClass.coursesIdTypeTypeIdDelete(
      { id: course_id, type: 'assigned', type_id: profile_uid },
      {},
      { queryParams: { manage: true } }
    )
      .then(() => activate())
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.toggleRow = item => (item.displayInfo = !item.displayInfo);

  vm.courseProgress = [
    { title: 'Date Assigned', class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1', sort: 'sortDate' },
    { title: 'Course', class: 'col-lg-4 col-md-4 col-sm-4 col-xs-4', sort: 'name' },
    { title: 'Credits', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2' },
    { title: 'Status', class: 'col-lg-1 col-md-1 col-sm-1 col-xs-1', sort: 'status' },
    { title: 'Module Progress', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2', sort: 'modules_taken' },
    { title: '', class: 'col-lg-2 col-md-2 col-sm-2 col-xs-2' }
  ];

  function activate() {
    $log.debug('Course Progress Component Activated');
    vm.loaded = false;
    vm.error = {};
    ApiClass.coursesGet(
      { courseType: false },
      {},
      {
        queryParams: {
          profile_uid,
          internal: true,
          vendor: true,
          filters: JSON.stringify({ requireAssigned: true })
        }
      }
    )
      .then(({ data: { courses } }) => {
        const assigned = courses.map(course => {
          const progress = course.progress || {};
          progress.modules_total = progress.modules ? Object.keys(progress.modules).length : 1;
          progress.modules_taken = progress.modules_taken || 0;
          const progressPercent = $filter('Progress')(progress.modules_taken, progress.modules_total);
          progress.progressBar = Number.isNaN(progressPercent) ? 0 : progressPercent;

          const { category_id, hours, credits, name, course_id } = course || {};
          // TODO: subject area need to be mapped for all courses

          progress.date = progress.date || progress.updated_at;
          progress.sortDate = new Date(progress.date).getTime();
          progress.credits = credits;
          progress.hours = hours;
          progress.name = name;
          progress.course_id = course_id;
          progress.status = $filter('Capitalize')(course.status);
          return progress;
        });
        vm.assigned = orderBy(assigned, ['sortDate'], ['desc']);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/users/progressAssignedCourses/controller.js